// extracted by mini-css-extract-plugin
export default {"root":"accounting__accounting-page__pages__organization-data-page__root","table":"accounting__accounting-page__pages__organization-data-page__table"};